import { render } from "./post_status_modal.vue?vue&type=template&id=b6b8d3a2"
import script from "./post_status_modal.js?vue&type=script&lang=js"
export * from "./post_status_modal.js?vue&type=script&lang=js"

import "./post_status_modal.vue?vue&type=style&index=0&id=b6b8d3a2&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__